const check = async () => {
	if (process.env.NODE_ENV !== 'production') {
		return Promise.reject(new Error('It will works on Production environment'));
	} else if (!('serviceWorker' in navigator)) {
		return Promise.reject(new Error('No Service Worker support!'));
	}
	// if (!('PushManager' in window)) {
	// 	reject('No Push API Support!');
	// }
};

const registerValidSW = (swUrl: string) =>
	navigator.serviceWorker.register(swUrl).then((registration) => {
		if (!navigator.serviceWorker.controller) {
			// The window client isn't currently controlled so it's a new service
			// worker that will activate immediately
			return registration;
		}

		if (registration.waiting) {
			window.location.reload();
		}

		const listenInstalledStateChange = () => {
			registration?.installing?.addEventListener('statechange', (event) => {
				if (registration.installing?.state === 'installed') {
					// A new service worker is available, inform the user
					window.location.reload();
				}
			});
		};

		if (registration.installing) {
			listenInstalledStateChange();
		}
		registration.addEventListener('updatefound', listenInstalledStateChange);

		return registration;

		// registration.addEventListener('updatefound', () => {
		// 	const installingWorker = registration.installing;
		// 	let refreshing = false;
		// 	installingWorker?.addEventListener('statechange', () => {
		// 		if (installingWorker.state == 'activated') {
		// 			if (refreshing) return;
		// 			window.location.reload();
		// 			refreshing = true;
		// 		}
		// 	});
		// 	if (installingWorker == null) {
		// 		return resolve(registration);
		// 	}
		// });
	});

function checkValidServiceWorker(swUrl: string, withCredentials?: boolean) {
	return fetch(swUrl, {
		headers: { 'Service-Worker': 'script' },
		credentials: withCredentials ? 'include' : 'omit',
	}).then((response) => {
		// Ensure service worker exists, and that we really are getting a JS file.
		const contentType = response.headers.get('content-type');
		if (
			response.status === 404 ||
			(contentType != null && contentType.indexOf('javascript') === -1)
		) {
			// No service worker found. Probably a different app. Reload the page.
			navigator.serviceWorker.ready.then((registration) => {
				registration.unregister().then(() => {
					window.location.reload();
				});
			});
		} else {
			// Service worker found. Proceed as normal.
			return registerValidSW(swUrl);
		}
	});
}

export const register = (
	baseUrl: string,
	serviceWorkerName: string,
	data?: object
) => {
	const qs_data = new URLSearchParams();
	qs_data.append('baseUrl', baseUrl);
	if (data) {
		Object.entries(data).forEach(([key, value]) => qs_data.append(key, value));
	}

	const swUrl = new URL(
		`./static/js/${serviceWorkerName}.js?${qs_data.toString()}`,
		baseUrl
	);
	const withCredentials = process.env.REACT_APP_FETCH_CREDENTIALS === 'true';

	return check().then(() =>
		checkValidServiceWorker(swUrl.href, withCredentials)
	);
};

export const unregister = () => {
	return check().then(() =>
		navigator.serviceWorker
			.getRegistrations()
			.then((regs) => Promise.all(regs.map((reg) => reg.unregister())))
	);
};
